import React, { act, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import Select from 'react-select'

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Form,
} from "reactstrap"

//Import Breadcrumb
import { Link } from 'react-router-dom';
import { useState } from "react";
import { useRef } from "react";
import { PropTypes } from 'prop-types';
import { Alert } from "reactstrap";
import { getClientDetail, getProducts, getProviderDetail, getRegimenesFiscales, getSatUseCfdi, postClient, postProvider, putClient, putProvider, validateZipCode } from "helpers/backend_helper";
import BreadcrumbNav from "components/Common/BreadcrumbNav";

import toastr from "toastr"
import { useNibbleForm } from "components/Nibble/Hooks/UseNibbleForm";
import * as Yup from 'yup';
import { MEXICO_STATES } from "helpers/states";
import Tabs, { tabsClients } from "./components/Tabs";
import DeliveryAddress from "./components/Branches";
import ProductsAssigned from "./components/ProductsAssigned";
import Branches from "./components/Branches";
import Trucks from "./components/Trucks";

const cpRegExp = /^[0-9]{5}/;

const CatalogProviderForm
  = (props) => {
    const isEdit = props?.location?.state?.id ? true : false;
    const breadcrumbItems = [
      { id: '1', title: 'Catálogos', link: '', active: false },
      { id: '2', title: 'Proveedores', link: '/catalogs/providers', active: false },
      { id: '3', title: isEdit ? 'Editar' : 'Crear', link: '', active: true }
    ];

    // Catalogs
    const [satUseCfdi, setSatUseCfdi] = useState([])
    const [satRegimenFiscal, setSatRegimenFiscal] = useState([])
    const [productos, setProductos] = useState([])

    // States
    const [model, setModel] = useState({ ...props.location.state })
    const [error, setError] = useState(null)
    const [completed, setCompleted] = useState(null)
    const [btnSaveLoad, setBtnSaveLoad] = useState(false)
    const [activeTab, setActiveTab] = useState('generales');

    async function getDataModel() {
      const response2 = await getProviderDetail(model.id)
      console.log('response2', response2)
      setModel({ ...model.invoice_address, ...model, ...response2, deliveries_address: response2.deliveries_address, distribuitors: response2.distribuitors })
    }

    useEffect(() => {
      getSatUseCfdi().then(setSatUseCfdi)
      getRegimenesFiscales().then(setSatRegimenFiscal)
      getProducts().then(setProductos)
      getDataModel();
    }, [])

    const { validation, render } = useNibbleForm({
      formScheme: [
        { md: 8, name: 'company_name', label: 'Nombre Comercial o Razón Social', type: 'text' },
        { md: 4, name: 'skey', label: 'Clave', type: 'text', },
        { md: 12, name: 'contact_name', label: 'Nombre del Contacto', type: 'text', },
        { md: 6, name: 'phone', label: 'Teléfono', type: 'text', },
        { md: 6, name: 'email', label: 'Correo Electrónico', type: 'email' },
        { md: 12, name: '', label: 'Dirección Fiscal', type: 'hidden', },
        { md: 12, name: 'rfc', label: 'RFC', type: 'text', },
        { md: 12, name: 'street', label: 'Calle', type: 'text', },
        { md: 4, name: 'ext_num', label: 'Num. Ext.', type: 'text', },
        { md: 4, name: 'int_num', label: 'Num. Int.', type: 'text', },
        { md: 4, name: 'cp', label: 'C.P.', type: 'text', },
        { name: 'location', label: 'Colonia', type: 'text', },
        { name: 'city', label: 'Ciudad/Municipio', type: 'text', },
        { name: 'state', label: 'Estado', type: 'select', selectItems: MEXICO_STATES, },
        { name: 'country', label: 'País', type: 'text', disabled: true, },
        /*
        {
          md: 6,
          name: 'productos',
          label: 'Productos Asignados Para Venta',
          type: 'multi-select',
          selectOptionValue: (option) => option.id,
          selectOptionLabel: (option) => option.name,
          selectItems: productos,
          onChange: (option) => {
            setSelectedRegion(option ? option.id : null)
          }
        },
        {
          md: 6,
          name: 'product_adjust',
          label: 'Máxima cantidad de ajuste por producto',
          type: 'number',
        },
        */
      ],
      validationScheme: Yup.object().shape({
        company_name: Yup.string().required('Requerido'),
        skey: Yup.string().nullable(),
        contact_name: Yup.string().required('Requerido'),
        rfc: Yup.string().nullable(),
        phone: Yup.string().nullable().required('Requerido'),
        email: Yup.string().email('Correo no válido').required("Requerido"),
        street: Yup.string().required('Requerido'),
        ext_num: Yup.string().required('Requerido'),
        int_num: Yup.string().nullable(),
        cp: Yup.string().matches(cpRegExp, 'Código postal no válido').required('Requerido'),
        location: Yup.string().required('Requerido'),
        city: Yup.string().required('Requerido'),
        state: Yup.string().required('Requerido'),
        country: Yup.string().required('Requerido'),
      }),
      defaultModelValues: {
        fee_per_unit: "1.00",
        country: 'México',
        city: 'Puebla',
        start: '10:00',
        end: '11:00'
      },
      model: { ...model },
      onSubmit: async (values) => {
        console.log('values', values)
        try {
          const resp = await validateZipCode({ cp: values.cp })
          if (!resp.cp) {
            toastr.error('Código postal no válido');
            return;
          };
        } catch (error) {
          console.log('error validating zip code', error)
          toastr.error(error);
        }

        setBtnSaveLoad(true)
        try {
          setError(null)
          const address = {
            street: values.street,
            ext_num: values.ext_num,
            int_num: values.int_num,
            cp: values.cp,
            location: values.location,
            city: values.city,
            state: values.state,
            country: values.country,
          }
          if (!isEdit) {
            const response = await postProvider({ ...values, address })
          } else {
            const response = await putProvider({ id: model.id, ...values, address })
          }
          setCompleted('Se completo la operación')
        } catch (error) {
          console.log('error', error)
          setError(error.toString())
          setCompleted(null)
        }
        setBtnSaveLoad(false)
      }
    })

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Catálogo de Proveedores</title>
          </MetaTags>
          <Container fluid={true}>
            <BreadcrumbNav title="Proveedores" items={breadcrumbItems} />
            <Row>
              <Col lg={12}>
                {isEdit &&
                  <Tabs tabActive={activeTab} setTabActive={setActiveTab} />
                }
                {activeTab == tabsClients.generales &&
                  <Card>
                    <CardBody>
                      {
                        //JSON.stringify(validation.values)
                      }
                      {
                        //JSON.stringify(validation.values)
                      }
                      <Form
                        className="form-horizontal"
                        onSubmit={(e, v) => {
                          e.preventDefault();
                          console.log('submit');
                          validation.handleSubmit()
                          return false;
                        }}
                      >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        {completed ? <Alert color="success">{completed}</Alert> : null}
                        <Row>
                          {render()}
                        </Row>
                        <div className="text-center mb-5 mt-4">
                          {(!completed || isEdit) &&
                            <button type="submit" className="btn btn-sm btn-danger w-md" disabled={btnSaveLoad}>
                              <i className="fas fa-save"></i> Guardar
                            </button>
                          }
                          <Link to="/catalogs/providers" className="btn w-md btn-sm btn-danger ms-2">
                            <i className="fas fa-reply"></i> Atrás
                          </Link>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                }
                {activeTab == tabsClients.sucursales &&
                  <Branches model={model} setModel={setModel} />
                }
                {activeTab == tabsClients.camiones &&
                  <Trucks model={model} setModel={setModel} />
                }
              </Col>
            </Row>
          </Container>
          {/* container-fluid */}
        </div>
      </React.Fragment>
    )
  }

CatalogProviderForm.propTypes = {
  provider: PropTypes.object,
  location: PropTypes.object,
};

export default CatalogProviderForm
